
<div class="container-fluid p-3">
  <div class="d-flex">
    <div class="settingsmenu d-flex flex-column bg-white rounded-left shadow-sm mt-2 mb-2">
      <div>
        <div v-for="(nav, index) in navItems" :key="index">
          <router-link
            tag="div"
            class="menuitem"
            :class="{ active: $route.name === nav.key }"
            :to="{
              name: nav.key,
              params: { occId: $route.params.occId },
            }"
          >
            <i :class="nav.icon"></i>
            <div class="nav-item-title">{{ nav.name }}</div>

            <i v-if="nav.additionalIcon && displayFilledWarning" :class="nav.additionalIcon" :title="nav.additionalIconPopover" v-b-tooltip:hover></i>
          </router-link>
        </div>
      </div>
      <div v-if="displayComatChart">
        <div class="label text-center mt-4">COMAT Process</div>
        <div class="mt-4 d-flex cursor-pointer align-items-center justify-content-center attachment" v-viewer="vvieweroptions">
          <div class="attachment-thumbnail">
            <img class="img-fluid" :src="'/comat_flow.png'" :data-src="'/comat_flow.png'" />
          </div>
        </div>
      </div>

      <div class="flex-grow-1 d-flex flex-column justify-content-end align-items-center">
        <div
          class="font-weight-bold cursor-pointer text-2xl mb-4"
          v-b-tooltip.hover
          :title="copyEmailToSpecialOccurrenceTitle"
          @click="copyEmailToSpecialOccurrence"
        >
          <i class="far fa-at fa-lg"></i>
          E-Mail2SO
        </div>
      </div>
    </div>

    <div class="bg-lightgray rounded-sm flex-grow-1 p-4 pl-5 pt-4 shadow-sm settingscontainer shadow-sm">
      <div style="min-width: 800px; max-width: 1550px">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
